import { BASE_URL } from "@/constants/endpoints";
import {
  PersonaDetalle,
  PersonDescription,
} from "@/pages/persons/schema/person.schema";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { objectToQueryStringWithArray } from "@/utils/query-string";
import { AxiosInstance } from "axios";

let personsApiPromise: Promise<AxiosInstance> | null = null;

const getPersonsApi = async () => {
  if (personsApiPromise) return personsApiPromise;
  personsApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return personsApiPromise;
};

export interface GetListadoPersonasProps {
  "P.Pagina"?: number;
  "P.Records"?: number;
  Nombre?: string;
  Apellido?: string;
  Dni?: string;
  Cuit?: string;
}

export interface GetListadoPersonasResponse {
  listado: PersonDescription[];
  totalPages: number;
  totalRecords: number;
}

export const getListadoPersonas = async (
  props: GetListadoPersonasProps,
): Promise<GetListadoPersonasResponse | null> => {
  const api = await getPersonsApi();
  if (!api) return null;
  const response = await api.get(
    `/Personas/GetListadoPersonas?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

interface GetPersonaDetalleProps {
  id: number;
}

export const getPersonaDetalle = async (
  props: GetPersonaDetalleProps,
): Promise<PersonaDetalle | null> => {
  const api = await getPersonsApi();
  if (!api) return null;
  const response = await api.get(
    `/Personas/GetPersonaDetalle?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export interface ExistePersonaProps {
  dni: string;
}

export const existePersona = async (props: ExistePersonaProps) => {
  const api = await getPersonsApi();
  if (!api) return null;
  const response = await api.get(
    `/Personas/ExistePersona?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export interface CreatePersonProps {
  cuenta: string;
  agro: boolean;
  apellido: string;
  apodo: string;
  cuit: string;
  dni: string;
  idEstadoCivil: number;
  sexoBiologico: number;
  fecha: string;
  hobbies: number[];
  localidad: string;
  mail: string;
  idNivelEstudio: number;
  nombre: string;
  idProfesion: number;
  telefono: string;
}

export const createPerson = async (props: CreatePersonProps) => {
  const api = await getPersonsApi();
  if (!api) return null;
  const response = await api.post(
    `/Personas/AgregarPersona?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export interface UpdatePersonProps {
  idPersona: number;
  apellido: string;
  apodo: string;
  cuit: string;
  dni: string;
  idEstadoCivil: number;
  agro: boolean;
  fecha: string;
  hobbies: number[];
  sexoBiologico: number;
  localidad: string;
  mail: string;
  idNivelEstudio: number;
  nombre: string;
  idProfesion: number;
  telefono: string;
}

export const updatePerson = async (props: UpdatePersonProps) => {
  const api = await getPersonsApi();
  if (!api) return null;
  const response = await api.put(
    `/Personas/EditarPersona?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export interface AssociateAccountToPersonProps {
  idPersona: number;
  cuenta: string;
}

export const associateAccountToPerson = async (
  props: AssociateAccountToPersonProps,
) => {
  const api = await getPersonsApi();
  if (!api) return null;
  const response = await api.put(
    `/Personas/AsociarCuenta?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export interface UnlinkAccountsProps {
  idPersona: number;
  cuentas: string[];
}

export const unlinkAccounts = async (props: UnlinkAccountsProps) => {
  const api = await getPersonsApi();
  if (!api) return null;
  const response = await api.put(
    `/Personas/DesasociarCuenta?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};

export interface UnlinkBeneficiariesProps {
  destinatarioIds: number[];
  idPersona: number;
}

export const unlinkBeneficiaries = async (props: UnlinkBeneficiariesProps) => {
  const api = await getPersonsApi();
  if (!api) return null;
  const response = await api.delete(
    `/AgendaDestinatarios/DesasociarDestinatario?${objectToQueryStringWithArray(props)}`,
  );
  return response.data;
};
